var e = setTimeout;
function t(t, n) {
  var u = n.useCachedSetTimeout ? e : setTimeout;
  return new Promise(function (e) {
    u(e, t);
  });
}
function n(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    u = n.useCachedSetTimeout,
    r = t(e, {
      useCachedSetTimeout: u
    });
  function o(e) {
    return r.then(function () {
      return e;
    });
  }
  return o.then = function () {
    return r.then.apply(r, arguments);
  }, o.catch = Promise.resolve().catch, o;
}
export default n;